import { Box, Button } from "@mui/material";
import Note from "components/common/note";
import Profile from "features/invoices/invoices/components/viewInvoice/profile/Profile";
import useApi from "hooks/useApi";
import { useEffect, useState } from "react";
import { BiLeftArrowAlt } from "react-icons/bi";
import { MdEditNote } from "react-icons/md";
import ReactLoading from "react-loading";

const ViewInvoice = ({ invoice_id, setViewInvoice }) => {
  const [viewNote, setViewNote] = useState(false);
  const { fetchData, loading } = useApi();
  const [invoice, setInvoice] = useState({});

  useEffect(() => {
    const getProfile = async () => {
      const endpoint = {
        method: "get",
        url: `/api/admin/invoice/show/${invoice_id}`,
      };
      const { success, data } = await fetchData(endpoint, false);
      if (success) setInvoice(data);
    };
    getProfile();
  }, []);

  return loading ? (
    <Box
      sx={{
        height: "calc(100vh - 162px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <ReactLoading
        type="cylon"
        color="#405189"
        height={"85px"}
        width={"100px"}
      />
    </Box>
  ) : (
    <Box sx={{ m: "-10px" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Button
          startIcon={<BiLeftArrowAlt />}
          onClick={() =>
            viewNote ? setViewNote(false) : setViewInvoice(false)
          }
        >
          {viewNote ? "View Invoice" : "View Invoice Table"}
        </Button>
        {!viewNote && (
          <Box>
            <Button
              variant="outlined"
              startIcon={<MdEditNote />}
              sx={{
                position: "absolute",
                right: "140px",
                top: "20px",
              }}
              onClick={() => setViewNote(true)}
            >
              Note
            </Button>
          </Box>
        )}
      </Box>
      {viewNote ? (
        <Box mt="20px">
          <Note
            id={invoice_id}
            related_id={invoice_id}
            related_to="invoice"
            table_note_key="notes"
            route="invoice"
            isInvoiceNote
          />
        </Box>
      ) : (
        <Box mt="-62px" p={1}>
          <Profile profile={invoice} loading={loading} />
        </Box>
      )}
    </Box>
  );
};

export default ViewInvoice;
